import { getObjectKeysAsObject } from "@checkout/helpers";
import { getPriceQuoteCipherText } from "@checkout/states/Cart/CartQuote/selectors";
import { ParentState } from "@checkout/types";
import type { DoneInvokeEvent } from "xstate";
import type { ParentContextWithTripInsurance } from "./context";
import type {
  SelectProvinceEvent,
  SelectTripInsuranceOptionEvent,
} from "./events";
import type { TripInsuranceProductsResponse } from "./types";

export const guards = {
  isInsuranceDisabled: (ctx: ParentContextWithTripInsurance, _event: unknown) =>
    !ctx.featureFlags?.enableInsurance,
  hasQuoteId: (ctx: ParentContextWithTripInsurance, _event: unknown) =>
    Boolean(ctx[ParentState.cartQuote].priceQuoteCipherText),
  notVisitedTripInsurance: (
    ctx: ParentContextWithTripInsurance,
    _event: unknown
  ) => !ctx[ParentState.insurance]?.visited,
  isEmptyTripInsuranceProductsResponse: (
    _ctx: ParentContextWithTripInsurance,
    event: DoneInvokeEvent<TripInsuranceProductsResponse>
  ) => {
    const data = event.data;
    return !data?.products?.length;
  },
  shouldFetchTripInsuranceForProvince: (
    ctx: ParentContextWithTripInsurance,
    event: SelectProvinceEvent
  ) => {
    const productsForSelectedProvince =
      ctx[ParentState.insurance]?.products?.[event.provinceCode];
    return !productsForSelectedProvince?.length;
  },
  hasSelectedInsuranceProduct: (
    _ctx: ParentContextWithTripInsurance,
    event: SelectTripInsuranceOptionEvent
  ) => Boolean(event.product),
  shouldSkipFetch: (ctx: ParentContextWithTripInsurance, _event: unknown) => {
    const provinceCode = ctx[ParentState.insurance]?.provinceCode;
    const productsForSelectedProvince =
      ctx[ParentState.insurance]?.products?.[provinceCode];

    if (!productsForSelectedProvince?.length) {
      return false;
    }

    const currentQuoteId = getPriceQuoteCipherText({ context: ctx });
    const lastFetchedQuoteId = ctx[ParentState.insurance]?.lastFetchedQuoteId;

    return (
      Boolean(currentQuoteId && lastFetchedQuoteId) &&
      currentQuoteId === lastFetchedQuoteId
    );
  },
};

export const GuardTypes = getObjectKeysAsObject(guards);
